import { useMemo, useState } from 'react';
import Paginacao from '../components/common/Paginacao';

export function usePaginacao(itens, porPagina = 15) {
  const [pagina, setPagina] = useState(1);
  const totalPaginas = Math.max(1, Math.ceil(itens.length / porPagina));
  const paginaAtual = Math.min(pagina, totalPaginas);

  const paginados = useMemo(() => {
    const inicio = (paginaAtual - 1) * porPagina;
    return itens.slice(inicio, inicio + porPagina);
  }, [itens, paginaAtual, porPagina]);

  const ComponentePaginacao = () => (
    <Paginacao
      pagina={paginaAtual}
      totalPaginas={totalPaginas}
      onChange={setPagina}
      totalItens={itens.length}
      porPagina={porPagina}
    />
  );

  return { paginados, Paginacao: ComponentePaginacao, pagina: paginaAtual, totalPaginas };
}
